import Modals from "components/Modal";
import { USER_ANALYTICS } from "navigation/routes";
import { Link } from "react-router-dom";
import { startCase } from 'lodash'
import useUserReport from "hook/reports/useUserReport";
import { excludedFields } from "utils/constants";
import Select from "components/innerComponents/Select";
import StateSelect from "components/common/Selects/StateSelect";
import LoadingIndicator from "components/LoadingIndicator";
import { Suspense, useState, useRef } from "react";
import CitySelect from "components/common/Selects/CitySelect";
import TableUser from "components/TableUser";
import { formatMoney } from "utils/functions";

const UserReport = () => {
  const { currentData, setCurrentData, open, setOpen, skipPageReset, columns, data,
    setData, current, edit, isLoading,
    setSearch, setSearchLevel, setSelectedCity2, setSelectedState2,
    searchLevel, search, setFrom, setTo, sFrom, sTo, pagesize, totalAmount
  } = useUserReport()
  const [selectedState, setSelectedState] = useState('')
  const [selectedCity, setSelectedCity] = useState('')
  const levels = [
    { id: 1, value: 'member', label: 'Member' },
    { id: 2, value: 'champion', label: 'Champion' },
    { id: 3, value: 'patriot', label: 'Patriot' }
  ];
  const tableRef = useRef(null);

  function getExcel() {
    if (tableRef.current && typeof tableRef.current.getExcel === 'function') {
      tableRef.current.getExcel();
    }
  }
  return (
    <>

      <div className="container-fluid px-4">
        <div className="d-sm-flex align-items-start justify-content-between mt-4">
          <div>
            <h1>User Report</h1>
            <ol className="breadcrumb mb-2">
              <li className="breadcrumb-item">Users </li>
              <li className="breadcrumb-item active">All</li>
            </ol>
          </div>
          <Link className="btn btn-primary mb-2" to={`../${USER_ANALYTICS}`} relative="path">View Analytics</Link>
        </div>
        <div className="card mb-4">
          <div className="card-header">
            <i className="fas fa-table me-1"></i>
            Donations
          </div>
          <div className="row">
            <div className="col-3">
              <input type='text' placeholder='Global Search Record' className="form-control"
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />
            </div>
            <div className="col-3" style={{ width: '20%' }}>
              <Select
                placeholder="Select Level"
                id="level"
                name="level"
                className="form-select"
                // selected={JSON.parse(selectedStatus)}
                handleChange={(e) => {
                  setSearchLevel(JSON.parse(e.target.value)?.id);
                }}
                options={levels}
              />

            </div>
            <div className="col-3" style={{ width: '20%' }}>
              <Suspense fallback={<LoadingIndicator />} >
                <StateSelect selectedCountry={{ id: '160' }} selected={selectedState} handleChange={(e) => {
                  setSelectedState(JSON.parse(e.target.value))
                  setSelectedState2(JSON.parse(e.target.value).id)
                  // formik.setFieldValue('state_id', JSON.parse(e.target.value)?.id)
                }} />
              </Suspense>

            </div>
            <div className="col-3" style={{ width: '20%' }}>

              <Suspense fallback={<LoadingIndicator />} >
                <CitySelect selectedState={selectedState} selected={selectedCity} handleChange={(e) => {
                  setSelectedCity(JSON.parse(e.target.value))
                  setSelectedCity2(JSON.parse(e.target.value).id)
                  // formik.setFieldValue('city_id', JSON.parse(e.target.value)?.id)
                }} />
              </Suspense>

            </div>
            <div className="col-3">
              <div className="filterParameters" id="filterParameters" style={{ marginTop: '0' }}>
                <div className="datePickerWrapper px-0">
                  <div className="d-sm-flex align-items-end gap-2">
                    <div className="form-inline">From:
                      <input type='date' className="form-control" onChange={(e) => {
                        setFrom(e.target.value);
                      }} />
                    </div>
                    <div className="form-inline">To:
                      <input type='date' className="form-control" onChange={(e) => {
                        setTo(e.target.value);
                      }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-3 d-flex justify-content-end align-items-end mb-4 ms-auto pr-3">
              <button
                className="btn btn-success"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  getExcel();
                }}
              >
                <i className="fas fa-file-excel me-1"></i> Download Excel
              </button>
            </div>
          </div>
          <div className="card-body">
            <TableUser
              ref={tableRef}
              columns={columns}
              data={data || []}
              setData={setData}
              skipPageReset={skipPageReset}
              pagesize={pagesize}
              filterTable={data?.length}
              isLoading={isLoading}
              fileName='Users'
            />
          </div>
        </div>
      </div>


      {/* <Modals
        show={open && current === 'view' && singleDonor}
        onHide={() => {
          debugger
          var cdd=singleDonor;
          setEdit(false);
          setOpen(false);
        }}
        title="View User"
        size="md"
        footer={
          <button
            type="button"
            className="btn btn-primary"
            disabled={singleDonor?.isLoading}
            onClick={() => {
              if (edit) {
                setEdit(false);
                updateMyData('donor');
              } else {
                setEdit(true);
              }
            }}
          >
           
            {edit ? 'Update' : 'Edit'}
          </button>
        }
      >
        {singleDonor?.isLoading && <LoadingIndicator />}
        <dl className="striped">
          {singleDonor?.data &&
            Object.entries(singleDonor?.data)?.map(([key, value]) =>
              excludedFields.includes(key) ? (
                []
              ) : key === 'state' || key === 'country' || key === 'city' ? (
                <div key={key} className="row">
                  <dt className="col-4">{`${startCase(key)} :`}</dt>
                  <dd className="col-8">{value?.name}</dd>
                </div>
              ) : key==='category'||key==='present_level_contribution'||key==='next_level_contribution'?(
                <div></div>
              )
              
              
              
              : key === 'updated_at' || key === 'created_at' ? (
                <div key={key} className="row">
                  <dt className="col-4">{`${startCase(key)} :`}</dt>
                  <dd className="col-8">
                    {format(new Date(value), 'yyyy/MM/dd')}
                  </dd>
                </div>
              ) : typeof value === 'boolean' ? (
                <div key={key} className="row">
                  <dt className="col-4">{`${startCase(key)} :`}</dt>
                  <dd className="col-8">{value ? 'Yes' : 'No'}</dd>
                </div>
              ) : (
                <div key={key} className="row">
                  <dt className="col-4">{`${startCase(key)} :`}</dt>
                  {(!edit || key === 'unique_id' || key === 'email') && (
                    <dd className="col-8">{value}</dd>
                  )}
                  {edit && key !== 'unique_id' && key !== 'email' && (
                    <div className="col-8">
                      {key === 'gender' ? (
                        <select
                          className="form-select"
                          defaultValue={value || ''}
                          onChange={(e) =>
                            setCurrentData({
                              ...currentData,
                              [key]: e.target.value,
                            })
                          }
                        >
                          <option value="" disabled>
                            Choose one...
                          </option>
                          <option value="female">Female</option>
                          <option value="male">Male</option>
                        </select>
                      ) : (
                        <input
                          className="form-control"
                          type={key === 'date_of_birth' ? 'date' : 'text'}
                          defaultValue={value}
                          onChange={(e) =>
                            setCurrentData({
                              ...currentData,
                              [key]: e.target.value,
                            })
                          }
                        />
                      )}
                    </div>
                  )}
                </div>
              )
            )}
        </dl>
      </Modals> */}






      <Modals show={open && current === 'view'}
        onHide={() => setOpen(false)} title='View User' size='md' >
        <dl className="striped">
          {currentData && Object.entries(currentData)?.map(([key, value]) =>
            excludedFields.includes(key) ? (
              []
            ) :
              typeof value !== 'string' && typeof value !== 'number' ? [] : <div key={key} className='row'>
                <dt className='col-4'>{`${startCase(key)} :`}</dt>
                {(!edit || key === 'id') && <dd className='col-8'>{value}</dd>}
                {edit && key !== 'id' && <div className="col-8"><input className="form-control" type="text" defaultValue={value} onChange={(e) => setCurrentData({ ...currentData, [key]: e.target.value })} /></div>}
              </div>)}
        </dl>
      </Modals>
    </>
  );
}

export default UserReport;
